import styled from "styled-components";

// prettier-ignore
//@ts-ignore
const MyStyled: typeof styled = typeof styled === 'function' ? styled : styled.default;

export default MyStyled;
